import React from "react"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import Helmet from "react-helmet"




export default class Template extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  }

  render() {
    return (
      <div>
        <Helmet
          title="Gatsby Default Starter"
          meta={[
            { name: "description", content: "Sample" },
            { name: "keywords", content: "sample, something" },
          ]}
        />
      <header className="in-grid flex jcsb pad-50">
          <Link to="/">
              <div>
                  <h2>Corey Brown</h2>
                  <p className="cb-caption">Front-end Developer &amp; Video Producer</p>
              </div>
          </Link>

          <nav className="flex">
            <Link to="/#video">
              <div className="flex fdr">
                <i className="ion-ios-videocam"></i>
                <p>Video</p>
              </div>
            </Link>

            <Link to="/#web">
              <div className="flex fdr">
                <i className="ion-at"></i>
                <p>Web</p>
              </div>
            </Link>

            <Link to="/#fam">
              <div className="flex fdr">
                <i className="ion-heart"></i>
                <p>Family</p>
              </div>
            </Link>
          </nav>
        </header>
        { this.props.children() }
        <footer>
         <div className="in-grid flex jcc pad-50">
             <a href="https://instagram.com/coreybrown89" target="_blank">Instagram |  </a>
             <a href="https://github.com/coreybrown89" target="_blank">GitHub | </a>
             <a href="https://www.linkedin.com/in/coreybrown89" target="_blank"> LinkedIn</a>
         </div>
     </footer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js